var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / minus"),React.createElement("g",{"id":"icons-/-minus","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("rect",{"id":"minus","fill":"#1E1E1E","x":"11","y":"0","width":"2","height":"24"}))]);
}

Minus.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Minus;

Minus.default = Minus;
